import React, { Component } from "react";

import "./Background.component.scss";

export default class Background extends Component {
    render() {
        return (
            <div id="Background">
                <div className="pattern"></div>

                <svg version="1.1" id="Layer_1" className="circuits" xmlns="http://www.w3.org/2000/svg"
            x="0px" y="0px" viewBox="0 0 872.4 779.9">
                    <g className="st0">
                        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="591.5429" y1="499.6311" x2="867.2296" y2="-91.5809">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st1" d="M738.4,272.4l-66.7,26.6L731.8,450l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-59.6-149.8l66.7-26.6L632.8,0h-2.6L738.4,272.4z">
                                <circle cx="50" cy="50" r="40" stroke="black" strokeWidth="3" fill="red" />
                            </path>
                        <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="284.3639" y1="620.1476" x2="563.8113" y2="20.8708">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st2" d="M371,292.3l23.8-9.5l24.8,62.3l-13.7,28.9l58.1,145.9l20.5-8.2L525.2,614L509,651.6l32.3,81.1
                            c-1.5,1.2-2.2,3.3-1.4,5.2c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-2-2.8-3.1-4.8-2.8l-31.9-80.1l16.2-37.6
                            l-42-105.5l-20.5,8.2L408.5,374l13.7-28.9l-26.1-65.5l-23.8,9.5L257.3,0h-2.6L371,292.3z"/>
                        <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="272.9097" y1="610.8165" x2="546.1672" y2="24.814">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st3" d="M365.1,307.3l23.6-9.4l16.7,41.9l-14.1,33.3l64.5,162l23.6-9.4l36.5,91.8L499.8,655l26.6,66.9
                            c-1.4,1.2-2,3.3-1.3,5.1c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-2-2.9-3.2-5-2.8l-26.2-65.9l16.2-37.6l-37.8-94.9
                            l-23.6,9.4l-63.2-158.9l14.1-33.3l-17.9-45.1l-23.6,9.4L245.5,0h-2.6L365.1,307.3z"/>
                        <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="580.2888" y1="486.9781" x2="849.45" y2="-90.2399">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st4" d="M725.2,265.7l-66.7,26.6l62.4,156.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-61.9-155.5l66.7-26.6L622.2,0h-2.6L725.2,265.7z"/>
                        <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="518.8028" y1="410.0553" x2="749.1468" y2="-83.919">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st5" d="M607,270.7l23.6-9.4l42,105.4l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6L632,258.2l-23.6,9.4L501.8,0h-2.6L607,270.7z"/>
                        <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="507.5457" y1="397.3987" x2="732.3669" y2="-84.732">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st6" d="M601.5,283.4l23.6-9.4l36.5,91.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-37.8-94.9l-23.6,9.4L491.2,0h-2.6L601.5,283.4z"/>
                        <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="495.7245" y1="397.6707" x2="720.0903" y2="-83.4834">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st7" d="M595.5,298.1l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4L479.4,0h-2.6L595.5,298.1z"/>
                        <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="599.5482" y1="206.9118" x2="764.2156" y2="-146.2186">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st8" d="M608.3,68.7l23.6-9.4l42,105.4l-16.2,37.6l15.5,38.9l22.3-8.9c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-20,8l-14.2-35.7l16.2-37.6L633.2,56.2l-23.6,9.4
                            L583.5,0h-2.6L608.3,68.7z"/>
                        <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="587.2175" y1="219.6662" x2="755.1095" y2="-140.3794">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st9" d="M602.7,81.4l23.6-9.4l36.5,91.8l-16.2,37.6l22.5,56.5l15-6c1.2,1.6,3.3,2.3,5.3,1.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-12.7,5.1l-21.2-53.4l16.2-37.6l-37.8-94.9l-23.6,9.4L572.9,0h-2.6L602.7,81.4z"
                            />
                        <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="569.0699" y1="236.431" x2="742.4264" y2="-135.3333">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st10" d="M596.7,96.1l23.6-9.4l30.8,77.4L635,201.7l28.4,71.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28-70.5l16.2-37.6l-32.1-80.6l-23.6,9.4L561.1,0h-2.6L596.7,96.1z"/>
                        <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="566.5784" y1="128.3259" x2="693.6683" y2="-144.2192">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st11" d="M588,113.2l23.6-9.4l18.7,46.9c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8L613,100.7l-23.6,9.4L545.5,0h-2.6L588,113.2z"/>
                        <linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="556.7358" y1="143.0737" x2="687.7722" y2="-137.9349">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64 }}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0 }}/>
                        </linearGradient>
                        <path className="st12" d="M582.5,125.9l23.6-9.4l20.6,51.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.5-54.1l-23.6,9.4L534.9,0h-2.6L582.5,125.9z"/>
                        <linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="545.5082" y1="154.8983" x2="679.3953" y2="-132.2236">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st13" d="M576.4,140.6l23.6-9.4l20.4,51.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8L601.4,128l-23.6,9.4L523,0h-2.6L576.4,140.6z"/>
                        <linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="527.4974" y1="216.3707" x2="684.4672" y2="-120.2522">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st14" d="M576.8,173.1l23.6-9.4l31.5,79.1l-21.4,8.5L586,189.6l8.9-3.5l14.1,35.5c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-15-37.8l-13.4,5.3l26.4,66.2l25.9-10.3l-33.3-83.6
                            l-23.6,9.4L510.5,0h-2.6L576.8,173.1z"/>
                        <linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="684.984" y1="443.0962" x2="932.5746" y2="-87.8634">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <polygon className="st15" points="698.2,85 722,75.5 746.8,137.8 733.1,166.7 791.1,312.5 811.6,304.4 852.4,406.7 836.2,444.3 
                            870.1,529.4 872.3,528.5 838.8,444.3 855,406.8 813,301.2 792.5,309.4 735.7,166.7 749.4,137.9 723.3,72.4 699.5,81.8 667,0 
                            664.4,0 	"/>
                        <linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="673.4145" y1="433.8628" x2="916.3436" y2="-87.1003">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <polygon className="st16" points="692.3,100 716,90.6 732.6,132.5 718.5,165.8 783,327.8 806.6,318.4 843.1,410.2 827,447.7 
                            855.2,518.6 857.4,517.7 829.6,447.8 845.8,410.2 808,315.3 784.4,324.7 721.1,165.8 735.3,132.5 717.3,87.5 693.7,96.9 655.2,0 
                            652.6,0 	"/>
                        <linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="662.8377" y1="430.7735" x2="903.3693" y2="-85.0482">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st17" d="M776.6,337.7l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4L644.9,0h-2.6L776.6,337.7z"/>
                        <linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="713.6766" y1="245.7729" x2="887.4729" y2="-126.9344">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st18" d="M718.4,39.8l23.6-9.4l42,105.4l-16.2,37.6L812,284.3c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-43.8-110l16.2-37.6L743.4,27.2l-23.6,9.4L705.2,0h-2.6L718.4,39.8z"/>
                        <linearGradient id="SVGID_19_" gradientUnits="userSpaceOnUse" x1="702.1713" y1="228.2055" x2="870.0106" y2="-131.7268">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st19" d="M712.9,52.5l23.6-9.4l36.5,91.8l-16.2,37.6l36.1,90.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-35.8-89.9l16.2-37.6L737.8,40l-23.6,9.4L694.6,0H692L712.9,52.5z"/>
                        <linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="689.5823" y1="213.4874" x2="851.9853" y2="-134.787">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st20" d="M706.9,67.1l23.6-9.4l30.8,77.4l-16.2,37.6l29,72.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28.6-71.9l16.2-37.6l-32.1-80.6L708.2,64L682.8,0h-2.6L706.9,67.1z"/>
                        <linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="380.5989" y1="506.3222" x2="635.6373" y2="-40.6093">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st21" d="M509.9,386.1l23.6-9.4l42,105.4l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-43.2-108.6l-23.6,9.4L358.5,0h-2.6L509.9,386.1z"/>
                        <linearGradient id="SVGID_22_" gradientUnits="userSpaceOnUse" x1="369.3425" y1="493.6676" x2="619.2307" y2="-42.2192">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st22" d="M504.4,398.9l23.6-9.4l36.5,91.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-37.8-94.9l-23.6,9.4L347.9,0h-2.6L504.4,398.9z"/>
                        <linearGradient id="SVGID_23_" gradientUnits="userSpaceOnUse" x1="357.5198" y1="493.9381" x2="606.3447" y2="-39.6684">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st23" d="M498.3,413.5l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6L523.3,401l-23.6,9.4L336.1,0h-2.6L498.3,413.5z"/>
                        <linearGradient id="SVGID_24_" gradientUnits="userSpaceOnUse" x1="468.2645" y1="306.4031" x2="626.1282" y2="-32.1366">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st24" d="M511.1,184.1l23.6-9.4l42,105.4l-16.2,37.6l15.5,38.9l43-17.1c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-40.7,16.2l-14.2-35.7l16.2-37.6l-43.2-108.6l-23.6,9.4
                            L440.2,0h-2.6L511.1,184.1z"/>
                        <linearGradient id="SVGID_25_" gradientUnits="userSpaceOnUse" x1="455.9325" y1="319.159" x2="621.1298" y2="-35.1077">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st25" d="M505.6,196.9l23.6-9.4l36.5,91.8l-16.2,37.6l22.5,56.5l35.7-14.2c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-33.4,13.3l-21.2-53.4l16.2-37.6l-37.8-94.9l-23.6,9.4
                            L429.6,0H427L505.6,196.9z"/>
                        <linearGradient id="SVGID_26_" gradientUnits="userSpaceOnUse" x1="432.062" y1="355.827" x2="616.9642" y2="-40.6968">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st26" d="M499.6,211.5l23.6-9.4l30.8,77.4l-16.2,37.6l39.4,99.1c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-39.1-98.2l16.2-37.6L524.6,199l-23.6,9.4L417.8,0h-2.6L499.6,211.5z"/>
                        <linearGradient id="SVGID_27_" gradientUnits="userSpaceOnUse" x1="428.3796" y1="224.5962" x2="566.7115" y2="-72.0575">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st27" d="M490.8,228.6l23.6-9.4l18.7,46.9c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-19.5-49.1l-23.6,9.4L402.2,0h-2.6L490.8,228.6z"/>
                        <linearGradient id="SVGID_28_" gradientUnits="userSpaceOnUse" x1="418.5431" y1="239.3468" x2="565.9882" y2="-76.8501">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st28" d="M485.3,241.3l23.6-9.4l20.6,51.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.5-54.1l-23.6,9.4L391.6,0H389L485.3,241.3z"/>
                        <linearGradient id="SVGID_29_" gradientUnits="userSpaceOnUse" x1="407.3135" y1="251.168" x2="561.8722" y2="-80.2843">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st29" d="M479.3,256l23.6-9.4l20.4,51.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.3-53.6l-23.6,9.4L379.8,0h-2.6L479.3,256z"/>
                        <linearGradient id="SVGID_30_" gradientUnits="userSpaceOnUse" x1="389.3017" y1="312.6408" x2="569.9157" y2="-74.687">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st30" d="M479.7,288.5l23.6-9.4l31.5,79.1l-21.4,8.5L488.8,305l8.9-3.5l14.1,35.5c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-15-37.8l-13.4,5.3l26.4,66.2l25.9-10.3L504.6,276
                            l-23.6,9.4L367.2,0h-2.6L479.7,288.5z"/>
                        <linearGradient id="SVGID_31_" gradientUnits="userSpaceOnUse" x1="190.7183" y1="672.5986" x2="493.6761" y2="22.9037">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st31" d="M411.2,479.7l-66.7,26.6l60.1,151.1l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-59.6-149.8l66.7-26.6L223,0h-2.6L411.2,479.7z"/>
                        <linearGradient id="SVGID_32_" gradientUnits="userSpaceOnUse" x1="179.4657" y1="659.9449" x2="475.6229" y2="24.8339">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st32" d="M398,473l-66.7,26.6l62.4,156.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8L380.1,694l16.2-37.6l-61.9-155.5l66.7-26.6L212.4,0h-2.6L398,473z"/>
                        <linearGradient id="SVGID_33_" gradientUnits="userSpaceOnUse" x1="198.7181" y1="379.8754" x2="390.1791" y2="-30.7141">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st33" d="M281.1,276l23.6-9.4l42,105.4l-16.2,37.6l15.5,38.9l22.3-8.9c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-20,8l-14.2-35.7l16.2-37.6L306,263.5l-23.6,9.4
                            L209.7,90c0,0,0,0-0.1,0L173.7,0h-2.6L281.1,276z"/>
                        <linearGradient id="SVGID_34_" gradientUnits="userSpaceOnUse" x1="186.4575" y1="392.6686" x2="381.4377" y2="-25.4678">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st34" d="M199.1,96.7C199.1,96.7,199.1,96.7,199.1,96.7l76.4,192.1l23.6-9.4l36.5,91.8l-16.2,37.6l22.5,56.5l15-6
                            c1.2,1.6,3.3,2.3,5.3,1.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-12.7,5.1l-21.2-53.4
                            l16.2-37.6l-37.8-94.9l-23.6,9.4L201.2,95.4c0,0,0,0-0.1,0L163.1,0h-2.4L199.1,96.7z"/>
                        <linearGradient id="SVGID_35_" gradientUnits="userSpaceOnUse" x1="168.24" y1="409.3953" x2="369.0105" y2="-21.1584">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st35" d="M269.5,303.4l23.6-9.4l30.8,77.4L307.8,409l28.4,71.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28-70.5l16.2-37.6l-32.1-80.6l-23.6,9.4l-79.3-199.2c0,0,0,0-0.1,0L151.3,0h-2.6
                            L269.5,303.4z"/>
                        <linearGradient id="SVGID_36_" gradientUnits="userSpaceOnUse" x1="165.75" y1="301.2925" x2="320.6691" y2="-30.9326">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st36" d="M260.8,320.5l23.6-9.4L303,358c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8L285.7,308l-23.6,9.4l-83.4-209.6c0,0,0,0-0.1,0L135.7,0h-2.6L260.8,320.5z"/>
                        <linearGradient id="SVGID_37_" gradientUnits="userSpaceOnUse" x1="155.9067" y1="316.0417" x2="315.0347" y2="-25.2095">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st37" d="M255.2,333.2l23.6-9.4l20.6,51.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.5-54.1l-23.6,9.4L169.8,112c0,0,0,0-0.1,0L125.1,0h-2.6L255.2,333.2z"/>
                        <linearGradient id="SVGID_38_" gradientUnits="userSpaceOnUse" x1="144.681" y1="327.8636" x2="306.9066" y2="-20.0304">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st38" d="M249.2,347.9l23.6-9.4l20.4,51.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.3-53.6l-23.6,9.4l-90.9-228.5c0,0,0,0-0.1,0L113.3,0h-2.6L249.2,347.9z"/>
                        <linearGradient id="SVGID_39_" gradientUnits="userSpaceOnUse" x1="126.6686" y1="389.3388" x2="312.1578" y2="-8.444">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st39" d="M249.6,380.4l23.6-9.4l31.5,79.1l-21.4,8.5l-24.6-61.7l8.9-3.5l14.1,35.5c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-15-37.8l-13.4,5.3l26.4,66.2l25.9-10.3l-33.3-83.6
                            l-23.6,9.4l-102.3-257c0,0-0.1,0-0.1,0L100.7,0h-2.6L249.6,380.4z"/>
                        <linearGradient id="SVGID_40_" gradientUnits="userSpaceOnUse" x1="262.006" y1="603.7373" x2="530.4831" y2="27.9864">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st40" d="M449.3,545l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4L235.2,0h-2.6L449.3,545z"/>
                        <linearGradient id="SVGID_41_" gradientUnits="userSpaceOnUse" x1="312.8902" y1="418.7585" x2="508.5274" y2="-0.7867">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st41" d="M391.2,247.1l23.6-9.4l42,105.4l-16.2,37.6l44.1,110.9c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-43.8-110l16.2-37.6l-43.2-108.6l-23.6,9.4L295.5,0h-2.6L391.2,247.1z"/>
                        <linearGradient id="SVGID_42_" gradientUnits="userSpaceOnUse" x1="301.3849" y1="401.1905" x2="487.9887" y2="1.0172">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st42" d="M385.7,259.8l23.6-9.4l36.5,91.8l-16.2,37.6l36.1,90.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-35.8-89.9l16.2-37.6l-37.8-94.9l-23.6,9.4L284.9,0h-2.6L385.7,259.8z"/>
                        <linearGradient id="SVGID_43_" gradientUnits="userSpaceOnUse" x1="288.7931" y1="386.472" x2="467.179" y2="3.9222">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st43" d="M379.7,274.4l23.6-9.4l30.8,77.4L417.9,380l29,72.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28.6-71.9l16.2-37.6l-32.1-80.6l-23.6,9.4L273.1,0h-2.6L379.7,274.4z"/>
                        <linearGradient id="SVGID_44_" gradientUnits="userSpaceOnUse" x1="48.9475" y1="527.7628" x2="285.0558" y2="21.4268">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st44" d="M98.4,186.5l23.8-9.5l24.8,62.3l-13.7,28.9l58.1,145.9l20.5-8.2l40.7,102.4l-16.2,37.6l33.9,85.1l2.2-0.9
                            L239,545.9l16.2-37.6l-42-105.6l-20.5,8.2l-56.8-142.7l13.7-28.9l-26.1-65.5l-23.8,9.5l-18.9-47.6c0,0-0.1,0-0.1,0L26.3,0h-2.6
                            L98.4,186.5z"/>
                        <linearGradient id="SVGID_45_" gradientUnits="userSpaceOnUse" x1="37.4487" y1="518.5609" x2="284.487" y2="-11.2146">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st45" d="M92.5,201.6l23.6-9.4l16.7,41.9l-14.1,33.2l64.5,162l23.6-9.4l36.5,91.8l-16.2,37.6l28.2,70.9l2.2-0.9
                            l-27.9-70l16.2-37.6l-37.8-94.9l-23.6,9.4l-63.2-158.9l14.1-33.3L117.5,189l-23.6,9.4l-24.1-60.7c0,0,0,0-0.1,0L14.7,0h-2.6
                            L92.5,201.6z"/>
                        <linearGradient id="SVGID_46_" gradientUnits="userSpaceOnUse" x1="26.8485" y1="515.4621" x2="263.7707" y2="7.3809">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st46" d="M176.8,439.2l23.6-9.4l30.8,77.4L215,544.9l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4l-118-296.6c0,0-0.1,0-0.1,0L4.4,0H1.8
                            L176.8,439.2z"/>
                        <linearGradient id="SVGID_47_" gradientUnits="userSpaceOnUse" x1="106.7294" y1="577.7784" x2="360.5898" y2="33.373">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st47" d="M118.6,141.3l23.6-9.4l42,105.4L168,274.9l44.1,110.9c-1.6,1.2-2.2,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-43.8-110l3.1-7.2l94.6,237.6l23.6-9.4l30.8,77.4L306.5,611l24.9,62.6
                            c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8L309.2,611l16.2-37.6
                            l-32.1-80.6l-23.6,9.4l-94.5-237.6l4.8-11.1l94.4,237.2l23.6-9.4l36.5,91.7l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-37.8-94.9l-23.6,9.4l-94.4-237.2
                            l4.2-9.7L279.8,478l23.6-9.4l42,105.4l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-43.2-108.6l-23.6,9.4l-94.4-237.3l0.1-0.2l-43.2-108.6
                            l-23.6,9.4l-3.6-9c0,0,0,0,0,0L64.6,0H62L118.6,141.3z"/>
                        <linearGradient id="SVGID_48_" gradientUnits="userSpaceOnUse" x1="66.1598" y1="312.8828" x2="223.2772" y2="-24.0567">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st48" d="M113.1,154.1l23.6-9.4l36.5,91.8L157,274l36.1,90.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8L159.7,274l16.2-37.6L138,141.5l-23.6,9.4l-7.9-19.7c0,0,0,0,0,0L54,0h-2.6
                            L113.1,154.1z"/>
                        <linearGradient id="SVGID_49_" gradientUnits="userSpaceOnUse" x1="53.559" y1="298.1588" x2="204.528" y2="-25.5953">
                            <stop  offset="0" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0.64}}/>
                            <stop  offset="0.8715" style={{
                                stopColor:"#FF8096",
                                stopOpacity: 0}}/>
                        </linearGradient>
                        <path className="st49" d="M107.1,168.7l23.6-9.4l30.8,77.4l-16.2,37.6l29,72.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28.6-71.9l16.2-37.6L132,156.2l-23.6,9.4l-12.8-32.3c0,0,0,0-0.1,0L42.2,0h-2.6
                            L107.1,168.7z"/>
                    </g>
                </svg>

                <div className="ball-rays">

                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                viewBox="0 0 421.3 386.5">
                        <g id="Ball_Ray_3">
                            <g className="rays-st3">
                                <g>
                                    <g>
                                        <g>
                                            <path className="rays-st1" d="M78,108.3c6.7-6.7,15.3-11.5,23.7-16.2c8.1-4.5,16.5-9.2,23-15.6c12.8-12.7,30.9-18.4,48.4-23.9
                                                c4.4-1.4,8.6-2.7,12.7-4.1c4.7-1.6,9.5-3.8,14.1-5.9c11-5,22.4-10.1,34.3-9.3c9.8,0.7,18.5,4.5,26.8,8.2
                                                c9.4,4.1,19.1,8.4,30.4,8.2c6.6-0.1,14.6-1.8,23.1-3.6c18.1-3.8,38.7-8.1,50,3c11.2,11,9,30.6,7.1,47.9
                                                c-0.7,6.8-1.5,13.2-1.4,18.8c0.1,9.1,2.9,18.2,5.6,26.9c3.3,10.9,6.8,22.1,5.1,33.5c-1.3,9.1-5.9,17.2-10.4,25
                                                c-3.9,6.9-8,14.1-9.8,21.9c-1.6,6.6-2.3,13.9-3.2,21.6c-1.9,17.8-3.8,36.2-15.8,48.2c-0.1,0.1-0.2,0.2-0.2,0.2
                                                c-13,12.7-30.6,17.6-47.7,22.2c-3.8,1-7.7,2.1-11.5,3.3c-4.3,1.3-8.7,3-13,4.6c-12.5,4.7-25.3,9.7-38.5,6.8
                                                c-8.7-1.9-16.4-6.2-23.8-10.3c-8.5-4.7-17.3-9.6-27.7-10.9c-6.1-0.8-12.7-0.3-19.7,0.1c-14.6,0.9-29.7,1.9-40.2-8.5
                                                c-3.2-3.1-6.5-6-9.8-8.9c-8.7-7.6-16.9-14.7-22-25.5c-7.3-15.5-7.6-32.8-8-49.5c-0.2-9.8-0.4-19.9-2-29.6
                                                c-1.1-6.4-3.1-13-5.2-19.9c-5.5-17.9-11.1-36.4,0.4-52.8C74.4,112.1,76.1,110.1,78,108.3z M341.1,292.5
                                                c11.8-11.8,13.7-30,15.6-47.7c0.8-7.8,1.6-15.1,3.2-21.8c1.9-8,6-15.2,9.9-22.1c4.4-7.8,9-15.8,10.3-24.7
                                                c1.7-11.3-1.8-22.4-5.1-33.1c-2.7-8.8-5.5-17.9-5.6-27.1c-0.1-5.7,0.6-12.1,1.4-18.9c1.9-17.1,4-36.5-6.9-47.2
                                                c-11.1-10.9-31.4-6.6-49.3-2.8c-8.5,1.8-16.5,3.5-23.3,3.6c-11.5,0.2-21.2-4.1-30.7-8.3c-8.3-3.7-16.9-7.5-26.5-8.1
                                                c-11.7-0.8-23,4.3-33.9,9.2c-4.7,2.1-9.5,4.3-14.2,5.9c-4.1,1.4-8.3,2.7-12.7,4.1c-17.4,5.5-35.4,11.1-48.1,23.7
                                                c-6.5,6.5-15,11.2-23.2,15.7c-10.6,5.9-21.5,12-28.5,22c-11.3,16.1-5.7,34.4-0.3,52.1c2,6.6,4.1,13.5,5.2,20
                                                c1.6,9.7,1.8,19.9,2,29.7c0.3,16.6,0.6,33.8,7.9,49.2c5,10.7,13.2,17.8,21.8,25.3c3.3,2.8,6.6,5.8,9.8,8.9
                                                c10.3,10.2,25.2,9.2,39.6,8.3c7-0.4,13.7-0.9,19.9-0.1c10.6,1.3,19.4,6.3,28,11c7.4,4.1,15,8.3,23.6,10.2
                                                c13,2.8,25.7-2,38.1-6.7c4.3-1.6,8.7-3.3,13-4.6c3.8-1.1,7.7-2.2,11.5-3.3c17-4.7,34.5-9.5,47.3-22
                                                C340.9,292.7,341,292.6,341.1,292.5z"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>


                    <div className="gradient-ball"></div>

                    <img src="/images/bubble.png" style={{
                        maxWidth: "307px",
                        maxHeight: "307px" }}/>

                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                    viewBox="0 0 421.3 386.5">
                        <g id="Ball_Ray_1">
                            <g className="rays-st0">
                    
                                <g>
                                    <g>
                                        <g>
                                            <path className="rays-st1" d="M285.4,29.2c7.6,7.5,12.9,17.2,18,26.6c5,9.1,10.2,18.6,17.4,25.8c14.2,14.3,20.5,34.7,26.5,54.5
                                                c1.5,5,3,9.7,4.5,14.3c1.8,5.3,4.2,10.7,6.5,15.9c5.5,12.4,11.2,25.2,10.1,38.7c-0.9,11.1-5.3,20.9-9.6,30.4
                                                c-4.8,10.7-9.7,21.7-9.6,34.4c0.1,7.5,1.9,16.5,3.8,26.1c4.1,20.5,8.8,43.6-4,56.6c-12.5,12.8-34.7,10.5-54.2,8.6
                                                c-7.7-0.8-14.9-1.5-21.3-1.4c-10.3,0.2-20.6,3.5-30.5,6.6c-12.3,3.9-25,7.9-37.9,6.1c-10.2-1.4-19.4-6.5-28.2-11.5
                                                c-7.8-4.3-15.8-8.8-24.7-10.9c-7.4-1.7-15.7-2.5-24.4-3.3c-20.1-1.9-40.9-3.9-54.3-17.4c-0.1-0.1-0.2-0.2-0.3-0.3
                                                c-14.2-14.5-19.5-34.4-24.6-53.7c-1.1-4.3-2.3-8.7-3.6-13c-1.4-4.8-3.3-9.8-5.1-14.6c-5.2-14-10.6-28.6-7.2-43.5
                                                c2.2-9.9,7.2-18.6,11.9-27.1c5.4-9.7,11.1-19.7,12.7-31.4c0.9-6.9,0.5-14.4,0.1-22.3c-0.9-16.5-1.8-33.5,10.1-45.6
                                                c3.6-3.6,6.9-7.4,10.1-11.1c8.6-9.9,16.8-19.2,29.1-25.1c17.6-8.5,37.2-9,56.1-9.5c11.1-0.3,22.5-0.6,33.5-2.5
                                                c7.3-1.3,14.7-3.6,22.5-6.1c20.3-6.4,41.2-12.9,59.7-0.1C281.1,25.2,283.4,27.2,285.4,29.2z M74.2,328.8
                                                c13.2,13.2,33.8,15.2,53.8,17.1c8.8,0.8,17.1,1.6,24.6,3.3c9,2.1,17.1,6.6,24.9,11c8.8,4.9,17.8,10,27.9,11.3
                                                c12.7,1.7,25.3-2.2,37.5-6.1c10-3.1,20.3-6.4,30.7-6.6c6.4-0.1,13.7,0.6,21.4,1.4c19.3,1.9,41.2,4.2,53.5-8.3
                                                c12.4-12.6,7.8-35.5,3.7-55.8c-1.9-9.6-3.8-18.7-3.8-26.3c-0.1-13,4.9-24.1,9.7-34.8c4.2-9.4,8.6-19.2,9.5-30.1
                                                c1-13.3-4.6-26-10.1-38.3c-2.3-5.2-4.7-10.7-6.5-16c-1.6-4.6-3-9.4-4.5-14.4c-6-19.6-12.2-39.9-26.2-54.1
                                                c-7.3-7.3-12.5-16.8-17.6-26c-6.5-11.9-13.3-24.2-24.5-32c-18.1-12.6-38.8-6.1-58.9,0.2c-7.5,2.4-15.3,4.8-22.7,6.1
                                                c-11,1.9-22.5,2.2-33.6,2.6c-18.8,0.5-38.3,1.1-55.7,9.4C95.1,48.4,87,57.7,78.4,67.5c-3.2,3.7-6.6,7.5-10.2,11.2
                                                c-11.6,11.8-10.7,28.6-9.8,44.9c0.4,8,0.8,15.5-0.1,22.5c-1.6,12-7.3,22-12.8,31.8c-4.7,8.4-9.6,17-11.8,26.8
                                                c-3.3,14.7,2,29.1,7.2,43c1.8,4.8,3.7,9.8,5.1,14.7c1.2,4.2,2.4,8.7,3.6,13c5.1,19.2,10.3,39,24.4,53.3
                                                C74.1,328.6,74.1,328.7,74.2,328.8z"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="Ball_Ray_2">
                            <g className="rays-st2">
                                <g>
                                    <g>
                                        <g>
                                            <path className="rays-st1" d="M292.1,386.5c-11.4,0-22.7-3.3-33.7-6.5c-10.7-3.1-21.8-6.3-32.6-6.4c-21.5-0.1-41.6-10.8-61.1-21.1
                                                c-4.9-2.6-9.6-5.1-14.2-7.4c-5.3-2.6-11.2-4.9-16.9-7.1c-13.5-5.2-27.5-10.6-36.9-21.6c-7.7-9-11.8-19.8-15.7-30.2
                                                c-4.4-11.7-9-23.7-18.7-33.3c-5.7-5.6-13.9-11.1-22.6-16.8C21.2,223.9,0.2,209.9,0,190.5c-0.2-19.1,18.2-34.1,34.5-47.4
                                                c6.4-5.2,12.4-10.1,17.1-15c7.6-8,12.9-18.1,18-28c6.4-12.2,12.9-24.8,24-33.3c8.8-6.7,19.5-9.7,29.9-12.6
                                                c9.1-2.6,18.6-5.3,26.8-10.4c6.9-4.3,13.7-10,21-15.9C187.9,14.2,205.1,0,225.4,0c0.1,0,0.3,0,0.4,0
                                                c21.7,0.2,40.7,11.3,59.1,21.9c4.1,2.4,8.3,4.8,12.5,7.1c4.7,2.6,9.9,4.9,14.9,7.2c14.5,6.6,29.6,13.5,38.3,27.4
                                                c5.8,9.2,8.7,19.5,11.4,29.4c3.2,11.4,6.5,23.2,14.2,33.3c4.5,5.9,10.5,11.3,16.8,16.9c13.1,11.8,26.7,23.9,26.8,42
                                                c0,5.4,0.4,10.8,0.7,16.1c0.9,14,1.8,27.2-3,40.9c-6.9,19.7-21.3,34.9-35.1,49.5c-8.1,8.6-16.5,17.5-23.4,27.2
                                                c-4.5,6.5-8.4,13.8-12.4,21.6c-10.5,20.1-21.4,40.9-45,45.2C298.4,386.2,295.3,386.5,292.1,386.5z M225.4,1
                                                c-20,0-37,14.1-53.5,27.7c-7.3,6-14.1,11.7-21.1,16c-8.3,5.2-17.9,7.9-27.1,10.5c-10.3,2.9-21,5.9-29.6,12.5
                                                c-10.9,8.3-17.4,20.8-23.7,32.9c-5.2,9.9-10.5,20.1-18.2,28.2c-4.8,5-10.8,9.9-17.2,15.1C19,157,0.8,171.9,1,190.5
                                                c0.2,18.9,21,32.7,39.3,44.9c8.7,5.8,16.9,11.3,22.7,16.9c9.9,9.7,14.5,21.9,18.9,33.6c3.9,10.3,8,21,15.6,29.9
                                                c9.2,10.8,23.1,16.1,36.5,21.3c5.7,2.2,11.6,4.5,17,7.1c4.7,2.3,9.3,4.8,14.3,7.4c19.3,10.3,39.3,21,60.6,21
                                                c11,0,22.1,3.3,32.9,6.4c13.9,4,28.3,8.2,42.7,5.6c23.1-4.2,33.9-24.7,44.3-44.6c3.9-7.5,7.9-15.2,12.5-21.7
                                                c6.9-9.8,15.3-18.7,23.5-27.3c13.8-14.6,28.1-29.7,34.9-49.2c4.8-13.6,3.9-26.7,3-40.5c-0.4-5.2-0.7-10.7-0.8-16.1
                                                c-0.1-17.6-13.5-29.7-26.4-41.3c-6.3-5.7-12.3-11-16.9-17c-7.8-10.2-11.1-22.1-14.3-33.6c-2.8-9.9-5.6-20.1-11.3-29.2
                                                c-8.6-13.6-23.5-20.4-37.9-27c-5-2.3-10.2-4.7-14.9-7.3c-4.1-2.3-8.4-4.7-12.5-7.1C266.2,12.2,247.3,1.2,225.9,1
                                                C225.7,1,225.6,1,225.4,1z"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                </div>


                <img className="stripes" src="/images/stripes.png" />

                <div className="blinks">
                    <div className="blink-01 time-01" style={{
                        right: "46.7%",
                        top: "12.3%"
                    }}></div>
                    <div className="blink-01" style={{
                        right: "49%", 
                        top: "44.5%"
                        }}></div>
                    <div className="blink-01 time-01" style={{
                        right: "36.1%", 
                        top: "29.1%"
                        }}></div>
                    <div className="blink-01" style={{
                        right: "40%", 
                        top: "47.3%" 
                        }}></div>
                    <div className="blink-01 time-01" style={{
                        right: "25.2%", 
                        top: "33.5%" 
                        }}></div>
                    <div className="blink-01" style={{
                        right: "36.9%", 
                        top: "73.3%" 
                        }}></div>
                    <div className="blink-01 time-01" style={{
                        right: "22%", 
                        top: "74.7%", 
                        zIndex: -1
                        }}></div>

                    <div className="blink-02 time-01" style={{
                        right: "40.2%", 
                        top: "36.6%" 
                        }}></div>
                    <div className="blink-02" style={{
                        right: "32.1%", 
                        top: "37.4%" 
                        }}></div>
                    <div className="blink-02 time-01" style={{
                        right: "47.5%", 
                        top: "70%" 
                        }}></div>
                    <div className="blink-02" style={{
                        right: "35.8%", 
                        top: "56%" 
                        }}></div>
                    <div className="blink-02 time-01" style={{
                        right: "13.9%", 
                        top: "54.4%" 
                        }}></div>
                    <div className="blink-02" style={{
                        right: "35%", 
                        top: "87.3%" 
                        }}></div>
                    <div className="blink-02 time-01" style={{
                        right: "32.7%", 
                        top: "71.9%" 
                        }}></div>
                </div>

            </div>
        );
    }
}
